var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[this.$root.$data.miniprogram ? '' : 'activeRule_top']},[_c('common-title',{attrs:{"titleName":"活动规则","bcColor":'#F7F8FC',"isAPPShow":true}}),_c('div',{staticClass:"activeRule"},[_c('div',{staticClass:"rule_text",domProps:{"innerHTML":_vm._s(_vm.ruleText)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }